export enum CallTransferType {
  NOT_ASSISTED = 0,
  ASSISTED = 1
}
